import { ButtonClean, Heading } from '@fourthwall/components';
import React from 'react';
import * as S from './styled';
export const Header = () => (React.createElement("div", { style: { marginBottom: 32 } },
    React.createElement(Heading, { type: "h5", weight: "bold" }, "Perks and tiers"),
    React.createElement(S.Subheading, null,
        "Perks determine the benefits that members get by signing up for one of your paid tiers.",
        ' ',
        React.createElement(ButtonClean, { label: "Learn more", appearance: "secondary", href: "https://help.fourthwall.com/hc/en-us/articles/13331327040539-Memberships-Quick-Start-Guide", target: "_blank", withUnderline: true }))));
